<script setup lang="ts"></script>
<template>
  <div class="hero-section">
    <div class="hero-title">Брокер Пасс</div>
    <div class="hero-subtitle">доступ в профессиональное сообщество CRE.ru</div>

    <div class="hero-header">
      <div class="header-logo">
        <img class="logo-ellipse" src="./images/logo.svg" alt="Logo" />
      </div>
      <nav class="header-nav">
        <NuxtLink to="#about-project" class="nav-link">О проекте</NuxtLink>
        <NuxtLink to="#get-broker-pass" class="nav-link">
          Получить Брокер Пасс
        </NuxtLink>
      </nav>
    </div>

    <div class="hero-content">
      <div class="hero-description-wrapper">
        <div class="hero-description">
          Присоединись к сети консультантов и брокеров по коммерческой
          недвижимости и получи преимущества от ведущей отраслевой платформы
        </div>
      </div>
      <NuxtLink to="#get-broker-pass" class="hero-cta-button-large">
        <div class="cta-button-text">Получить Брокер Пасс</div>
      </NuxtLink>
      <div class="hero-cta-note">Это займёт не больше минуты</div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@use './styles/styles.scss' as *;
.hero-section {
  background: #111111 url('./images/topsection-back.png') no-repeat center
    right / cover;
  height: 848px;
  position: relative;
  overflow: hidden;

  @media (max-width: $tablet-view) {
    height: 632px;
  }

  @media (max-width: $mobile-view) {
    height: 642px;
  }

  .hero-title {
    color: var(--white, #ffffff);
    @include font-regular;
    font-size: 120px;
    line-height: 100%;
    text-transform: uppercase;
    position: absolute;
    left: 129px;
    top: 155px;

    @media (max-width: $tablet-view) {
      font-size: 70px;
      left: 30px;
      top: 154px;
    }

    @media (max-width: $mobile-view) {
      left: 20px;
      top: calc(286px - 56px);
      font-size: 56px;
      display: flex;
      height: calc(56px * 2);
      align-items: flex-end;
    }
  }

  .hero-subtitle {
    color: var(--white, #ffffff);
    @include font-regular;
    font-size: 64px;
    line-height: 100%;
    position: absolute;
    left: 129px;
    top: 293px;
    width: 860px;

    @media (max-width: $tablet-view) {
      font-size: 34px;
      left: 30px;
      top: 254px;
      width: 430px;
    }

    @media (max-width: $mobile-view) {
      left: 20px;
      top: 352px;
      font-size: 24px;
      width: 310px;
    }
  }

  .hero-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 31px 129px 0;
    position: relative;

    @media (max-width: $tablet-view) {
      margin: 30px;
    }

    @media (max-width: $mobile-view) {
      margin: 30px 18px 30px 20px;
    }

    .header-logo {
      width: 110px;
      height: 40px;
      position: relative;

      @media (max-width: $tablet-view) {
        height: 30px;
        width: 90px;
        min-width: 90px;
      }

      .logo-text {
        height: 100%;
      }

      .logo-ellipse {
        display: inline-block;
        margin-right: 3px;
        height: 100%;

        @media (max-width: $tablet-view) {
          margin-right: 2px;
        }
      }
    }

    .header-nav {
      display: flex;
      gap: 50px;
      justify-content: flex-end;

      @media (max-width: $mobile-view) {
        gap: 20px;
        flex-wrap: wrap;
      }

      .nav-link {
        color: var(--white, #ffffff);
        @include font-medium;
        font-size: 24px;
        line-height: 100%;
        min-width: fit-content;
        text-decoration: none;

        @media (max-width: $mobile-view) {
          font-size: 14px;
        }
      }
    }
  }

  .hero-content {
    display: flex;
    gap: 30px;
    flex-direction: column;
    position: absolute;
    right: 129px;
    top: 454px;
    width: 750px;

    @media (max-width: $tablet-view) {
      width: 720px;
      right: 30px;
      top: 412px;
      gap: 23px;
      flex-direction: row;
      flex-wrap: wrap;
    }

    @media (max-width: $mobile-view) {
      width: unset;
      right: 10px;
      left: 10px;
      top: 426px;
      gap: 10px;
      flex-direction: column;
    }

    .hero-description-wrapper {
      background-color: white;
      padding: 30px;

      @media (max-width: $mobile-view) {
        padding: 16px;
      }

      .hero-description {
        color: #111;
        @include font-regular;
        font-size: 32px;
        line-height: 130%; /* 41.6px */

        @media (max-width: $tablet-view) {
          font-size: 18px;
        }

        @media (max-width: $mobile-view) {
          font-size: 14px;
        }
      }
    }

    .hero-cta-button-large {
      border-radius: 6px;
      border: 0 solid var(--Chiness-Black, #111);
      background: var(--tangerine, #f26628);
      box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
      height: 54px;
      padding: 15px 40px;
      justify-content: center;
      align-items: center;
      display: flex;
      width: 320px;
      text-decoration: none;

      @media (max-width: $mobile-view) {
        width: 100%;
      }

      .cta-button-text {
        color: var(--White, #fff);
        @include font-medium;
        font-size: 24px;
        line-height: 100%; /* 24px */

        @media (max-width: $mobile-view) {
          font-size: 16px;
        }
      }
    }

    .hero-cta-note {
      color: var(--light-gray, #e8e8e8);
      @include font-regular;
      font-size: 22px;
      line-height: 100%;

      @media (max-width: $tablet-view) {
        display: flex;
        align-items: center;
        font-size: 18px;
      }

      @media (max-width: $mobile-view) {
        width: 100%;
        justify-content: center;
      }
    }
  }
}
</style>
